export default "__VITE_ASSET__BRsY1w5R__"